<script>
  import { g_tabs, g_activeTab, pjpath, g_tree_content } from "./common.js";
  import {
    getIconForFile,
    getIconForFolder,
    getIconForOpenFolder
  } from "vscode-icons-js";

  export let name;
  export let path;
  export let size;
  export let extension;
  export let type;
  let tree_content;
  const unsubscribe_tree_content = g_tree_content.subscribe(value => {
    tree_content = value;
    console.log(value);
  });
  function addtabs() {
    tree_content[0].map(obj => {
      if (obj.path == path) {
        // console.log("addtabs", obj.path + " vs " + path);
        if ($g_tabs.filter(t => t.path === obj.path).length == 0) {
          $g_tabs.push(obj);
          g_tabs.set($g_tabs);
        } else {
          $g_tabs.map((t, i) => {
            if (t.name === obj.name) {
              g_activeTab.set(i);
              return false;
            }
          });
        }
        return false;
      }
    });
  }
</script>

<style>
  span {
    padding: 0 0 0 1.5em;
    background: 0 0.1em no-repeat;
    background-size: 1em 1em;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: smaller;
  }
</style>

<span
  title={name}
  style="background-image:url('./icons/{getIconForFile('.' + name)}');white-space:
  nowrap;overflow: hidden;text-overflow: clip;"
  on:click={addtabs}>
  {name}
</span>
